export default __webpack_public_path__ + "static/media/p35.71b7cab0.jpg";